import { useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useCommonStore, useUserStore } from "@stores/index";
import { useUserLogout } from "@providers/index";

export const LogoutPage = () => {
  const isAuth = useCommonStore(({ isAuth }) => isAuth);
  const setCommonState = useCommonStore(({ setState }) => setState);
  const resetCommonState = useCommonStore(({ resetState }) => resetState);
  const business = useUserStore(({ business }) => business);
  const resetUserState = useUserStore(({ resetState }) => resetState);

  const {
    mutate,
    isPending: isPendingUserLogout,
    isSuccess,
  } = useUserLogout(() => {
    resetCommonState();
    resetUserState();
  });

  useEffect(() => {
    mutate();
  }, [mutate]);

  useEffect(() => {
    setCommonState({ isLoading: isPendingUserLogout });
  }, [isPendingUserLogout, setCommonState]);

  if (isSuccess && !isAuth && !business) {
    return <Navigate to="/login" />;
  }

  return null;
};
